(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("axios"), require("react-router-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "axios", "react-router-dom"], factory);
	else if(typeof exports === 'object')
		exports["@platform/api/index"] = factory(require("react"), require("react-dom"), require("axios"), require("react-router-dom"));
	else
		root["@platform/api/index"] = factory(root["React"], root["ReactDOM"], root["axios"], root["ReactRouterDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__46__, __WEBPACK_EXTERNAL_MODULE__355__) {
return 